import React, { useEffect, useState } from 'react';

//UI
import { Grid, Paper, Typography, Button } from '@material-ui/core';
// import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { PackageType, CountOrderIdPair, ReportOrderItem } from '../interfaces';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import Modal from '../../../components/Modal';
import JalaliUtils from '@date-io/jalaali';
import CustomizedSelect from './components/customizedSelect';
import CustomDatePicker from './components/customDatepicker';

import List from './components/packReportTable';
import ModalList from './components/modalTable';

//Request Repo
import PackageManagementRepository from 'client-sdk/src/Repository/packagesManagement-repository';
import useQuery from '../../../utils/hook/useQuery';
import { dateFormater } from '../../../utils/helpers';

import { mdiHomeSearchOutline } from '@mdi/js';
import { mdiStateMachine } from '@mdi/js';
import { mdiCalendar } from '@mdi/js';
import handleError from '../../../utils/handleError';
import handleNotfication from '../../../utils/handleNotfication';

//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      // '@media (max-width: 480px)': {
      //   marginLeft: '75px',
      // },
    },
    //Aryan
    shadow: {
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        boxShadow: '0px 3px 24px rgba(0, 0, 0, 0.06)',
        transform: 'rotate(-180deg)',
      },
    },

    checkboxLabel: {
      fontWeight: 400,
      fontSize: '13px',
    },
    paper: {},
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    mdiDresserIcon: {
      color: '#329926',

      // backgroundColor: '#D6EBD3',
    },
    mdiClipboardMultipleOutlineIcon: {
      color: '#6276F7',
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },

    cardContentOrder: {
      padding: '0',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    closeIcon: {
      color: '#EC4040',
      backgroundColor: '#F7B3B3',
      borderRadius: '5px',
      padding: '5px',
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      marginTop: '45px',

      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(1),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      marginTop: '5px',
      padding: '10px',
      display: 'flex',
      flexDirection: 'row-reverse',
      // width: '100%',
      '@media (max-width: 480px)': {
        display: 'none',
        flexDirection: 'column-reverse',
        width: '100%',
      },
    },
    titleBar: {
      padding: '8px 2px',
      width: '100%',
      borderRadius: '0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '@media (max-width: 480px)': {
        width: '100%',
        marginLeft: '-70px',

        marginTop: '55px',
        flexDirection: 'column',
        alignItem: 'center',
        fontSize: '12px',
      },
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
      '@media (max-width: 480px)': {
        marginLeft: '-5px',

        fontSize: '12px',
      },
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    select: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      cursor: 'pointer',
    },
    datePickerRelated: {
      maxWidth: '164px',
    },
  })
);

//Constant variables


const PackConsumption = (props: {}) => {
  let headCells = [];

  headCells = [
    { id: 'id', label: 'شناسه', type: 'input' },
    { id: 'name', label: 'نام', type: 'input' },
    { id: 'dimensions', label: 'ابعاد', type: 'input' },
    { id: 'weight', label: 'وزن', type: 'input' },
    { id: 'consumed', label: 'تعداد بسته مصرف شده', type: 'input' },
  ];

  const mainTableHead = { headCells };

  //Pop up modal table related data
  let modHeadCells = [];

  modHeadCells = [
    { id: 'id', label: 'شناسه', type: 'input' },
    { id: 'tracking-code', label: 'کد رهگیری', type: 'input' },
    { id: 'order-status', label: 'وضعیت سفارش', type: 'input' },
    { id: 'package-count', label: 'تعداد بسته مصرفی', type: 'input' }
  ];

  const modalTableHead = { headCells: modHeadCells };

  //Copied from Payment -- END
  const userId = localStorage.getItem('partnerId') as unknown;
  const [activePackCat, setActivePackCat] = useState<PackageType | undefined>(
    undefined
  );
  const [packageInfoList, setPackageInfoList] = useState<PackageType[]>([]);
  const [packageOptions, setPackageOptions] = useState<PackageType[]>([]);
  const [countOrderList, setCountOrderList] = useState<CountOrderIdPair[]>([]);
  const [consumingOrdersList, setConsumingOrdersList] = useState<
    ReportOrderItem[] | undefined
  >(undefined);

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [options, setOptions] = useState<string[]>([]);
  const [openOrderList, setOpenOrderList] = useState<boolean>(false);

  const classes = useStyles();
  //Initialization
  useEffect(() => {
    getRelatedPackageTypes('ALL');
  }, []);

  useEffect(() => {
    if (activePackCat) {
      getPackageReportOrders();
    }
  }, [countOrderList]);

  const onPackageCatChange = event => {
    setActivePackCat(event.target.value);
  };

  //HandleStart and End Date
  const handleStartDateChange = date => {
    const dateObj = new Date(date);
    setStartDate(dateFormater(dateObj));
  };

  const handleEndDateChange = date => {
    const dateObj = new Date(date);
    setEndDate(dateFormater(dateObj));
  };

  const handleOpenOrdersParent = () => {
    console.log('modal open');
    setOpenOrderList(true);
  };

  const getRelatedPackageTypes = async (specifiedType: string) => {
    const action = {
      payload: {
        'partnerId.equals': userId,
        packageType: specifiedType,
      },
    };
    try {
      const response = await PackageManagementRepository.getAllPackageTypes(
        action
      );
      setPackageInfoList(response.data);
      setPackageOptions(response.data);
    } catch (error) {
      handleError(error);
    }
  };

  const getSinglePackage = async (code: string) => {
    const action = {
      payload: {
        'code.equals': code
      }
    };
    try {
      const response = await PackageManagementRepository.getPackagesExcel(
        action
      );
      setPackageInfoList(response.data);
    } catch (error) {
      handleError(error);
    }
  }

  const getPackageCountOrder = async (packageId: number) => {
    const action = {
      params: {
        startDate: startDate,
        endDate: endDate,
        packageIds: packageId,
      },
    };

    if (startDate !== null && endDate !== null && activePackCat !== undefined) {
      const response = await PackageManagementRepository.getPackageCountOrders(
        action
      );
      setCountOrderList(response.data);
      //when count orderList changes, filter the table and update the modal table.
      return response.data;

    } else {
      handleNotfication('لطفا نوع بسته‌بندی و تاریخ‌ها را انتخاب نمایید.', 'warn');
    }

  };

  const getPackageReportOrders = async () => {
    const action = {
      params: {
        startDate: startDate,
        endDate: endDate,
      },
      id: activePackCat?.id,
    };
    const response =
      await PackageManagementRepository.getPackageReportOrderList(action);
    setConsumingOrdersList(response.data.reportOrderList);
  };

  return (
    <React.Fragment>
          <Typography variant="h6" component="h2">
            {'مدیریت بسته‌بندی'}
          </Typography>
      <div
        style={{
          backgroundColor: '#FFF',
          marginTop: '24px',
          borderRadius: '4px',
        }}
      >
        {/* <Grid
          style={{
            zIndex: 3,
            backgroundColor: 'white',
            position: 'fixed',
            top: '0',
            right: '71px',
          }}
          container
        >
          <Paper elevation={0} className={classes.titleBar}>
            <div className={classes.headerBox}>
            </div>
            <div
              style={{
                marginLeft: '140px',
                display: 'flex',
              }}
            ></div>
          </Paper>
        </Grid> */}

        <Paper
          elevation={0}
          style={{
            padding: '24px',
          }}
        >
          <Typography
            style={{
              fontSize: '16px',
              fontWeight: '400',
            }}
          >
            تنظیمات گزارش مصرف
          </Typography>
          <div
            style={{
              marginTop: '24px',
              display: 'flex',
              flexDirection: 'row',
              alignContent: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignContent: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '12px',
              }}
            >
              <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                {options && (
                  <CustomizedSelect
                    label="* نام بسته‌بندی"
                    value={activePackCat?.name}
                    onChange={onPackageCatChange}
                    options={packageOptions}
                  />
                )}
              </Grid>
              <Grid
                item
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyItems: 'center',
                }}
              >
                <MuiPickersUtilsProvider utils={JalaliUtils} locale={'fa'}>
                  <CustomDatePicker
                    label={'از تاریخ'}
                    // defaultValue={new Date()}
                    onChange={handleStartDateChange}
                    value={startDate}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale={'fa'}>
                  <CustomDatePicker
                    label={'تا تاریخ'}
                    value={endDate}
                    onChange={handleEndDateChange}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
            </div>
            <Grid item style={{ display: 'flex' }}>
              <Button
                size="large"
                variant="contained"
                color="primary"
                onClick={() => {
                  getPackageCountOrder(activePackCat?.id as number)
                  getSinglePackage(activePackCat?.code)
                }}
              >
                {' اعمال تغییرات'}
              </Button>
            </Grid>
          </div>

          <Paper
            elevation={0}
            className={classes.shadow}
            style={{ marginTop: '24px' }}
          >
            <List
              data={packageInfoList}
              count={countOrderList.length > 0 ? countOrderList : []}
              handleOpenOrders={handleOpenOrdersParent}
              head={mainTableHead}
            />
          </Paper>
        </Paper>
      </div>
      <Modal
        maxWidth="md"
        onClose={() => setOpenOrderList(false)}
        open={openOrderList}
        content={
          <React.Fragment>
            <div
              style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                gap: '8px',
              }}
            >
              <ModalList
                data={consumingOrdersList as ReportOrderItem[]}
                count={[]}
                head={modalTableHead}
              />
              {/*
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                }}
              >
                <Button size="large" variant="contained" color="primary">
                  Excel
                </Button>
              </div>
              */}
            </div>
          </React.Fragment>
        }
      />
    </React.Fragment>
  );
};

export default PackConsumption;
